var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bv-loading-container",class:{ 'bv-loading-container-fullscreen': _vm.fullscreen }},[_c('div',{staticClass:"loading-message-box"},[_c('ion-spinner',{staticClass:"spinner"}),_c('ion-label',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }